import styles from './ListNavigation.module.css';
import { useMemo } from 'react';
import { useListDrawerContext } from '../ListDrawerProvider';
import ListDrawerToolbar from '../ListDrawerToolbar';
import ListGroupItem from './ListGroupItem';
import ListItem from './ListItem';
import classNames from 'classnames';

const ListNavigation = () => {
  const { groups, items, hasToolbar, renderListItem, styleConfig } = useListDrawerContext();

  const groupsMemo = useMemo(() => {
    return groups?.map((group, index) => <ListGroupItem key={index} group={group} />);
  }, [groups]);

  const itemsMemo = useMemo(
    () =>
      items?.map((item, index) =>
        renderListItem === undefined ? (
          <ListItem key={index} item={item} />
        ) : (
          renderListItem(item, index)
        ),
      ),
    [groups, items, renderListItem],
  );

  return (
    <div className={classNames(styles.container, styleConfig?.listNavigationContainer)}>
      {hasToolbar && <ListDrawerToolbar />}
      <div className={styles.overflow_y}>
        <table className={styles.table}>
          <tbody>
            {groupsMemo}
            {itemsMemo}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListNavigation;
